var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rb-not-found-frame"},[_c('rb-empty-state',{attrs:{"title":"Страница не найдена","description":"Проверьте правильность ссылки","icon":"mdi-close-circle-outline"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }